const getFirstAlphabet = (firstName, lastName) => {
  return firstName?.charAt(0).toUpperCase() + lastName?.charAt(0).toUpperCase();
};

export default getFirstAlphabet;
